import {Image, Text, ButtonProps, Button} from '@chakra-ui/react';

import {useTriviaStore} from '../../state';
import type {ImageAnswer as ImageAnswerT} from '../../types';

interface ImageAnswerProps extends ButtonProps {
  answer: ImageAnswerT;
  questionAnsweredCorrectly: boolean;
}

export const ImageAnswer = ({answer, questionAnsweredCorrectly, ...props}: ImageAnswerProps) => {
  const isActive = useTriviaStore((state) => !!state.currentAnswer.find(({id}) => id === answer.id));

  const isCorrect = isActive && questionAnsweredCorrectly;

  return (
    <Button
      data-testid="answer"
      pos="relative"
      variant="unstyled"
      maxW="36"
      h="unset"
      p="1px"
      borderWidth="1px"
      borderColor="gray.400"
      outline="1px solid transparent"
      rounded="1.125rem"
      bg="white"
      fontSize="sm"
      fontWeight="400"
      transitionProperty="border-color, outline-color"
      transitionDuration="0.2s"
      sx={{aspectRatio: '1 / 1'}}
      _hover={{borderColor: 'gray.500'}}
      _active={{
        fontWeight: 600,
        color: isCorrect ? 'green.400' : 'black',
        borderColor: 'currentColor',
        outlineColor: 'currentColor',
      }}
      {...props}
      isActive={isActive}
      isDisabled={props.isDisabled && !isActive}
    >
      <Image src={answer.media_url} alt="" boxSize="full" objectFit="cover" rounded="1rem" />

      {answer.body && (
        <Text
          pos="absolute"
          inset="1px"
          top="auto"
          p="2"
          color={isCorrect ? 'white' : 'black'}
          bg={isCorrect ? 'green.400' : '#fbfbfb'}
          roundedBottom="1rem"
          noOfLines={1}
          transitionProperty="background, color"
          transitionDuration="0.3s"
          userSelect="none"
          onCopy={(e) => e.preventDefault()}
        >
          {answer.body}
        </Text>
      )}
    </Button>
  );
};
